<template>
  <div class="query">
    <!--导航部分-->
    <div class="nav" style="padding-bottom: 56px;">
      <van-nav-bar
              fixed
              title="陈氏分支"
              left-arrow
              @click-left="onClickLeft"
      />
    </div>
    <!--搜索-->
    <van-search v-model="searchQuery" placeholder="请输入名称搜索" />
    <!--列表-->
    <div style="height: 10px;"></div>
     <template v-for="item in filterItems()">
        <van-cell-group>
          <van-cell :title="item.name" :label="'始祖：'+item.first" is-link :url="item.url"/>
        </van-cell-group>
     </template>

  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'

export default {
    'name': 'Query',
    data() {
        return {
          searchQuery:'',
          list: [
            {id:1,name:'陈氏总谱',first:'妫满',url:'https://www.baijiayoupu.com/h5/#/clan/tree/index?projectId=GWW9yhoA3mtJ'},
            {id:2,name:'东莞虎门北栅凤冈陈氏族谱',first:'述公',url:''},
            {id:3,name:'汀州庄广州长湴陈氏族谱',first:'魁公',url:''},
          ]
        };
    },
    computed: {

    },
    methods: {
        ...mapActions(['requestReportQuery']),
        onClickLeft() {
            this.$router.push({path: '/home'});
        },
        filterItems() {
          const query = this.searchQuery.toLowerCase()
          if(this.list) {
            return this.list.filter(item =>
              item.name.toLowerCase().includes(query)
            )
          }
        }
    },
    components: {

    },
    mounted() {

    }
};
</script>

<style scoped>
.query >>> .van-nav-bar {
  z-index: 9;
  background-color: #ed3f2c;
  padding-top: 6px;
}
.query >>> .van-nav-bar__text {
  color: #fff;
}
.query >>> .van-nav-bar__title {
  color: #fff;
}
.query >>> .van-nav-bar .van-icon {
  color: #fff;
}
.query >>> .van-button--primary {
  color: #fff;
  background-color: #ed3f2c;
  border: 0.02667rem solid #ed3f2c;
}
</style>
